import { useChannelTalk } from '@repo/channel-talk';
import { useUserEventLogger } from '@repo/tracking-service';
import { LottiePlayer } from '@repo/ui';
import { Button } from '@zenterprise-inc/ui';
import cn from 'clsx';
import { useRouter } from 'next/router';

import common from '@/components/survey/common/ui/styles/common.module.scss';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { COMMON_PATHS } from '@/lib/constants/paths';

export const SurveyCompletedContainer = () => {
  const router = useRouter();
  const { openChannelTalk } = useChannelTalk();
  const { sendClickEvent } = useUserEventLogger();

  return (
    <main className={cn(common.main_cta_space, 'flex h-screen flex-col')}>
      <article className={'my-auto'}>
        <section className={'flex flex-col items-center'}>
          <div className={'h-20 w-20'}>
            <LottiePlayer src={'/lotties/ani_check.json'} loop={false} />
          </div>
          <div className={'flex flex-col items-center gap-1 py-4 text-center'}>
            <h1 className={'headline-20'}>모든 답변을 제출 완료했어요!</h1>
            <p className={'body-16 text-gray-700'}>
              제휴 세무사가 검토를 진행할게요.
              <br />
              진행 과정은 알림톡으로 안내해드릴게요.
            </p>
          </div>
        </section>
      </article>

      <Button.StickyBottom.Wrapper className={'px-4.5'}>
        <Button.StickyBottom.Button
          type={'button'}
          onClick={() => {
            openChannelTalk(SUPPORT_BOT_LINK.home);
            sendClickEvent('survey_completed_cx');
          }}
        >
          문의하기
        </Button.StickyBottom.Button>
        <Button.StickyBottom.Button
          type={'button'}
          state={'primary'}
          onClick={() => {
            router.push(COMMON_PATHS.환급조회목록);
            sendClickEvent('survey_completed_to-home');
          }}
        >
          홈으로
        </Button.StickyBottom.Button>
      </Button.StickyBottom.Wrapper>
    </main>
  );
};
